<script>

  export let color;
  export let experts;
  export let conversation;
  export let updateConversation;

</script>

<style type="text/sass">

div
  height: 50px
  overflow: hidden
  width: 100vw

ul
  display: flex
  color: white
  list-style: none
  margin: 0
  padding: 0
  height: 100%
  border-top: .5px solid

li
  flex: 1
  display: flex
  align-items: center
  justify-content: space-around
  color: white
  cursor: pointer
  text-transform: uppercase
  white-space: nowrap
  user-select: none
  font-weight: 600
  font-size: 18px

.active
  opacity: 1
  font-size: 22px
  font-weight: 700

@media (max-width: 800px)
  .author-name
    display: none

</style>

<div>
  <ul class="flex">
    {#each experts as title, i}
      <li
        id={title}
        style="background: { i==conversation ? color : color+'77' }"
        on:click="{() => updateConversation(i)}"
      >
        <span>Chat {i+1} <span class="author-name">: {title}</span></span>
      </li>
    {/each}
  </ul>
</div>
